// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"477":"243815c8","787":"cd6a6b1d"}[chunkId] + ".chunk.js";
};